/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_DiversifiedInputs */

const en_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I am a diversified investor.`)
};

const de_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich investiere breit gestreut.`)
};

const pt_br2_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invisto de forma diversificada.`)
};

const tr_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çeşitlendirilmiş yatırım yaparım.`)
};

const zh_cn2_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我注重分散投资。`)
};

const zh_hk2_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我注重分散投資。`)
};

const ko_kr2_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저는 분산 투자자입니다.`)
};

const ru_ru2_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я придерживаюсь диверсифицированного подхода.`)
};

const es_419_onboarding_v1_profile_diversified = /** @type {(inputs: Onboarding_V1_Profile_DiversifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invierto de forma diversificada.`)
};

/**
* | output |
* | --- |
* | "I am a diversified investor." |
*
* @param {Onboarding_V1_Profile_DiversifiedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_diversified = /** @type {((inputs?: Onboarding_V1_Profile_DiversifiedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_DiversifiedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_diversified(inputs)
	if (locale === "de") return de_onboarding_v1_profile_diversified(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_diversified(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_diversified(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_diversified(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_diversified(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_diversified(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_diversified(inputs)
	return es_419_onboarding_v1_profile_diversified(inputs)
});